<template>
  <div>
    <template>
      <div class="d-none d-md-block text-h2 mb-4 mt-6">{{ $t('profile.security') }}</div>
      <UpdatePassword :disabled="userDeactivated" />
      <Multifactor />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AccountSettingsSecuritySettings',
  computed: {
    ...mapGetters({
      userDeactivated: 'profile/dashboard/userDeactivated'
    })
  }
};
</script>
